import { defineMessages } from 'react-intl';

export default defineMessages({
  noDropdownOptions: {
    id: 'noDropdownOptions',
    defaultMessage: 'There are no options to select.',
  },
});
